import React, { useState, useEffect, useCallback } from 'react';
import { client } from 'cccisd-apollo';
import Loader from 'cccisd-loader';
import notification from 'cccisd-notification';
import sitesQuery from './sitesQuery.graphql';
import OneTimeLink from './OneTimeLink';
import PrePostLinks from './PrePostLinks';
import OpenLinksTable from './OpenLinksTable';
import ClosedLinksTable from './ClosedLinksTable';

const Fortress = window.cccisd.fortress;

const GroupLink = () => {
    const [loading, setLoading] = useState(true);
    const [sites, setSites] = useState([]);
    const [assignmentId, setAssignmentId] = useState(null);
    const [surveyHandle, setSurveyHandle] = useState(null);
    const [org, setOrg] = useState(null);
    const [openDeployments, setOpenDeployments] = useState([]);
    const [closedDeployments, setClosedDeployments] = useState([]);

    const fetchGroupLinkData = useCallback(async () => {
        setLoading(true);
        try {
            const orgId = Fortress.user.acting.group_id;
            const response = await client.query({
                query: sitesQuery,
                fetchPolicy: 'network-only',
                variables: {
                    orgFilter: `org_${orgId}`,
                },
            });

            setSites(response.data.groups.siteList || []);
            setOrg(response.data.groups.organization || null);
            setAssignmentId(response.data.flows.assignment.assignmentId || null);
            setSurveyHandle(response.data.flows.assignment.survey.surveyHandle || null);
            setOpenDeployments(response.data.flows.assignment.open || []);
            setClosedDeployments(response.data.flows.assignment.closed || []);
        } catch (error) {
            notification({
                type: 'danger',
                message: 'Unable to load Group Link data. Please refresh and try again.',
            });
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchGroupLinkData();
    }, [fetchGroupLinkData]);

    if (loading) {
        return <Loader loading />;
    }

    return (
        <div>
            <h1>Group Link</h1>
            <div className="d-flex justify-content-end">
                <OneTimeLink
                    sites={sites}
                    org={org}
                    assignmentId={assignmentId}
                    surveyHandle={surveyHandle}
                    onSuccess={fetchGroupLinkData}
                />
                <div style={{ marginLeft: '10px' }}>
                    <PrePostLinks
                        sites={sites}
                        org={org}
                        assignmentId={assignmentId}
                        surveyHandle={surveyHandle}
                        onSuccess={fetchGroupLinkData}
                    />
                </div>
            </div>
            <div style={{ marginTop: '20px' }}>
                <OpenLinksTable sites={sites} org={org} deployments={openDeployments} onSuccess={fetchGroupLinkData} />
            </div>
            <div style={{ marginTop: '20px' }}>
                <ClosedLinksTable
                    sites={sites}
                    org={org}
                    deployments={closedDeployments}
                    onSuccess={fetchGroupLinkData}
                />
            </div>
        </div>
    );
};

export default GroupLink;
